import React, { useState } from 'react';
import './TransparentBox.css';
import { submitExploreResponse } from '../../services/api';
import shoe2 from '../../assets/shoe2.png';

// TODO: Add your image URLs here
const SHOE_IMAGES = [
    shoe2,
    "https://i.postimg.cc/JhZqXKSs/adidas-yeezy-yeezy-boost-700-sun-16346557-43123011-2048.png",
    "https://i.postimg.cc/j5pbsyL6/jordan-air-jordan-1-low-og-trophy-room-home-24265952-55271727-2048.png",
    "https://i.postimg.cc/8cLVss62/jordan-air-jordan-1-retro-high-og-heritage-17767833-43165780-2048.png",
    "https://i.postimg.cc/2S0N1s1S/jordan-kids-air-jordan-3-gs-white-red-stardust-22998158-48846804-2048.png",
    "https://i.postimg.cc/FsQ48gtN/jordan-air-jordan-1-retro-high-og-unc-toe-19856413-45845003-2048.png",
    "https://i.postimg.cc/0y2L1VVR/new-balance-1906r-cordura-pocket-black-19418639-45668469-2048.png",
    "https://i.postimg.cc/BQc00LsD/jordan-jordan-air-ship-awake-ny-22685248-48934057-2048.png",
    "https://i.postimg.cc/KY1wRRX0/new-balance-2002r-brown-21790164-47211419-2048.png",
    "https://i.postimg.cc/R0q5KgtQ/new-balance-550-aime-leon-dore-white-navy-red-16813305-43049699-2048.png",
    "https://i.postimg.cc/v85Rrg4j/new-balance-574-yurt-salehe-bembury-forest-green-17647615-43057581-2048.png",
    "https://i.postimg.cc/Rh7j4yr9/new-balance-920-made-in-england-year-of-the-tiger-23058979-48908096-2048.png",
    "https://i.postimg.cc/HstfNq49/new-balance-996-made-in-usa-grey-22868412-54711240-2048.png",
    "https://i.postimg.cc/V6j7CtKW/nike-wmns-dunk-low-lx-pink-foam-19859165-45659510-2048.png",
    "https://i.postimg.cc/k5RY7z8Z/nike-sb-dunk-rayssa-leal-22465606-48928710-2048.png",
    "https://i.postimg.cc/dV1SxL0J/nike-dunk-low-se-if-lost-return-to-20208428-45663364-2048.png",
    "https://i.postimg.cc/dtnx68wW/nike-dunk-low-red-stardust-22686093-53027802-2048.png",
    "https://i.postimg.cc/TYTsnkML/nike-dunk-low-premium-co-jp-brown-snakeskin-20320381-45661097-2048-d79fff77-b6de-40a8-bc1f-5e112bf11.png",
    "https://i.postimg.cc/PfWcLgcn/new-balance-xc-72-casablanca-red-gold-17391022-43018826-2048.png",
    "https://i.postimg.cc/rskPnjDH/new-balance-fresh-foam-x-more-v4-wmns-lavender-23139784-48919636-2048.png",
    "https://i.postimg.cc/7Zq8KxFV/adidas-yeezy-yeezy-foam-runner-sulfur-18377450-45632686-2048.png",
    "https://i.postimg.cc/tgT0HBCn/jordan-air-jordan-1-high-switch-peach-18100869-43083569-2048.png",
    "https://i.postimg.cc/JzKwgfmW/jordan-air-jordan-1-lo-elevate-wmns-georgetown-20454713-45775889-2048.png",
    "https://i.postimg.cc/nc4fKsPr/jordan-air-jordan-1-low-gym-red-16357688-43126423-2048.png",
];

function TransparentBox({ onLike, onDislike }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const getNextImage = () => {
        const nextIndex = (currentIndex + 1) % SHOE_IMAGES.length;
        return nextIndex;
    };

    const handleResponse = async (response) => {
        try {
            setIsLoading(true);
            // Add artificial delay
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            const result = await submitExploreResponse(response);
            if (result.type === "ExploreEntity") {
                setIsTransitioning(true);
                // Wait for fade out animation
                await new Promise(resolve => setTimeout(resolve, 300));
                
                // Get next image in sequence
                const nextIndex = getNextImage();
                setCurrentIndex(nextIndex);
                
                // Reset transition state after fade in
                setTimeout(() => setIsTransitioning(false), 300);
            }
            
            // Call the parent handlers
            if (response === 'liked') {
                onLike();
            } else {
                onDislike();
            }
        } catch (error) {
            console.error('Error submitting response:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="transparent-box">
            <div className="heading-box">
                <h2>Explore various styles here 👟</h2>
            </div>
            <div 
                className={`style-image ${isTransitioning ? 'transitioning' : ''}`}
                style={{ backgroundImage: `url(${SHOE_IMAGES[currentIndex]})` }}
            ></div>
            <div className="like-dislike-buttons">
                <button 
                    className="button" 
                    onClick={() => handleResponse('disliked')}
                    disabled={isLoading || isTransitioning}
                >
                    <span>👎</span>
                </button>
                <button 
                    className="button" 
                    onClick={() => handleResponse('liked')}
                    disabled={isLoading || isTransitioning}
                >
                    <span>👍</span>
                </button>
            </div>
        </div>
    );
}

export default TransparentBox;